export default function Portfolio() {
  const projects = [
    {
      category: 'Infrastructure',
      title: 'Global Logistics Hub Development',
      location: 'Southeast Asia',
      scale: '2.5M sq ft',
      investment: '$450M',
      image: 'https://public.readdy.ai/ai/img_res/5a8c42a0edaec2db8201f5ea858fedaf.jpg',
      height: 'h-[340px]'
    },
    {
      category: 'Industrial',
      title: 'Advanced Manufacturing Complex',
      location: 'North America',
      scale: '850K sq ft',
      investment: '$320M',
      image: 'https://readdy.ai/api/search-image?query=state%20of%20the%20art%20manufacturing%20facility%20exterior%20modern%20industrial%20building%20with%20steel%20and%20glass%20architecture%20clean%20lines%20professional%20industrial%20photography%20blue%20sky%20background%20minimal%20surroundings&width=800&height=700&seq=port2&orientation=landscape',
      height: 'h-[400px]'
    },
    {
      category: 'Energy',
      title: 'Industrial Gas Production Facility',
      location: 'Middle East',
      scale: '450 acres',
      investment: '$680M',
      image: 'https://readdy.ai/api/search-image?query=industrial%20gas%20production%20plant%20with%20modern%20processing%20towers%20and%20pipelines%20clean%20industrial%20facility%20professional%20architecture%20photography%20clear%20sky%20organized%20layout%20minimal%20background%20elements&width=800&height=560&seq=port3&orientation=landscape',
      height: 'h-[280px]'
    },
    {
      category: 'Trade Infrastructure',
      title: 'Intermodal Transportation Hub',
      location: 'Europe',
      scale: '1.8M sq ft',
      investment: '$520M',
      image: 'https://readdy.ai/api/search-image?query=modern%20intermodal%20transportation%20terminal%20with%20rail%20and%20truck%20loading%20facilities%20organized%20cargo%20containers%20clean%20industrial%20design%20aerial%20perspective%20professional%20photography%20simple%20background&width=800&height=650&seq=port4&orientation=landscape',
      height: 'h-[360px]'
    },
    {
      category: 'Industrial Parks',
      title: 'Strategic Industrial Development Zone',
      location: 'Latin America',
      scale: '1,200 acres',
      investment: '$890M',
      image: 'https://readdy.ai/api/search-image?query=large%20scale%20industrial%20park%20development%20with%20modern%20factory%20buildings%20organized%20layout%20roads%20and%20infrastructure%20aerial%20view%20professional%20architectural%20photography%20clean%20design%20simple%20background&width=800&height=700&seq=port5&orientation=landscape',
      height: 'h-[400px]'
    },
    {
      category: 'Commodities',
      title: 'Agricultural Supply Chain Infrastructure',
      location: 'Africa',
      scale: '650K sq ft',
      investment: '$280M',
      image: 'https://readdy.ai/api/search-image?query=modern%20agricultural%20storage%20and%20processing%20facility%20with%20large%20silos%20and%20warehouses%20clean%20industrial%20architecture%20organized%20layout%20professional%20photography%20clear%20sky%20minimal%20background&width=800&height=560&seq=port6&orientation=landscape',
      height: 'h-[280px]'
    },
    {
      category: 'Media & Entertainment',
      title: 'Media & Entertainment Investment Division',
      location: 'Global',
      scale: 'Film · Music · News · Digital',
      investment: '$470M+',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cinematic%20film%20studio%20production%20set%20with%20dramatic%20gold%20and%20black%20lighting%20professional%20camera%20equipment%20dark%20atmospheric%20interior%20modern%20entertainment%20industry%20environment%20minimal%20background&width=800&height=600&seq=port-media01&orientation=landscape',
      height: 'h-[340px]'
    }
  ];

  return (
    <section id="portfolio" className="bg-black py-16 sm:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="mb-10 sm:mb-16 lg:mb-20">
            <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">OUR DEVELOPMENT PROJECTS</h2>
            <p className="text-white/75 text-sm sm:text-base font-light leading-relaxed max-w-3xl">
              Ark Capital™ works with experienced operators, engineers, and development teams to structure and finance large-scale industrial and infrastructure projects. Our investment strategy focuses on projects with strong long-term demand, strategic geographic positioning, and significant economic impact.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-7">
            {projects.map((project, index) => (
              <div
                key={index}
                className="bg-zinc-900 group cursor-pointer overflow-hidden hover:shadow-[0_0_40px_rgba(214,175,55,0.2)] transition-all duration-300"
              >
                {/* Image */}
                <div className="h-[220px] sm:h-[260px] overflow-hidden relative">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Gold accent bar */}
                <div className="h-1 bg-yellow-600 group-hover:h-2 transition-all duration-300"></div>

                {/* Content */}
                <div className="p-6 sm:p-8 lg:p-10">
                  <div className="text-yellow-600 text-[10px] tracking-[0.2em] uppercase mb-3">
                    {project.category}
                  </div>
                  <h3 className="text-white text-lg sm:text-xl lg:text-2xl font-bold mb-3 leading-tight">
                    {project.title}
                  </h3>
                  <div className="text-white/60 text-sm mb-3">
                    <div>{project.location} • {project.scale}</div>
                  </div>
                  <div className="text-white text-2xl sm:text-3xl font-bold">
                    {project.investment}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom link */}
          <div className="text-center mt-10 sm:mt-16">
            <a href="#" className="text-yellow-600 font-semibold tracking-wide hover:text-yellow-500 transition-colors inline-flex items-center gap-2 cursor-pointer">
              VIEW COMPLETE PORTFOLIO
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}